export const response_cliente_find = {
  description: 'Cliente encontrado exitosamente',
  type: 'object',
  properties: {
    message: { type: 'string' },
    data: {
      type: 'object',
      properties: {
        personas: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            razon_social: { type: 'string' },
            ruc: { type: 'string' },
            dv: { type: 'string' },
            naturaleza_receptor: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                codigo: { type: 'number' },
                descripcion: { type: 'string' },
                created_at: { type: 'string', format: 'date-time' },
                updated_at: { type: 'string', format: 'date-time' },
              },
            },
            tipo_contribuyente: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                codigo: { type: 'number' },
                descripcion: { type: 'string' },
                created_at: { type: 'string', format: 'date-time' },
                updated_at: { type: 'string', format: 'date-time' },
                usuario: { type: 'null' },
              },
            },
            tipo_documento_identidad: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                codigo: { type: 'number' },
                descripcion: { type: 'string' },
                created_at: { type: 'string', format: 'date-time' },
                updated_at: { type: 'string', format: 'date-time' },
                usuario: { type: 'null' },
              },
            },
            nro_documento: { type: 'string' },
            direccion: { type: 'null' },
            telefono: { type: 'null' },
            email: { type: 'string' },
            active: { type: 'boolean' },
            deleted: { type: 'boolean' },
            deleted_at: { type: 'null' },
            created_at: { type: 'string', format: 'date-time' },
            updated_at: { type: 'string', format: 'date-time' },
            usuario: { type: 'null' },
            ciudades: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                codigo: { type: 'number' },
                descripcion: { type: 'string' },
                distritos: {
                  type: 'object',
                  properties: {
                    id: { type: 'string' },
                    codigo: { type: 'number' },
                    descripcion: { type: 'string' },
                    departamentos: {
                      type: 'object',
                      properties: {
                        id: { type: 'string' },
                        codigo: { type: 'number' },
                        descripcion: { type: 'string' },
                        paises: {
                          type: 'object',
                          properties: {
                            id: { type: 'string' },
                            codigo: { type: 'string' },
                            descripcion: { type: 'string' },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

export const response_cliente_all = {
  description: 'Clientes obtenidos exitosamente',
  type: 'object',
  properties: {
    message: { type: 'string' },
    data: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          persona_id: { type: 'string' },
          tipo_operacion_id: { type: 'string' },
          nombre_fantasia: { type: 'string' },
          cod_cliente: { type: 'string' },
          personas: {
            type: 'object',
            properties: {
              id: { type: 'string' },
              razon_social: { type: 'string' },
              ruc: { type: 'string' },
              dv: { type: 'string' },
              naturaleza_receptor: {
                type: 'object',
                properties: {
                  id: { type: 'string' },
                  codigo: { type: 'number' },
                  descripcion: { type: 'string' },
                  created_at: { type: 'string', format: 'date-time' },
                  updated_at: { type: 'string', format: 'date-time' },
                  usuario: { type: 'null' },
                },
              },
            },
          },
        },
      },
    },
  },
};

export const response_cliente_standard = {
  description: 'Cliente actualizado exitosamente',
  type: 'object',
  properties: {
    message: { type: 'string' },
    data: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        persona_id: { type: 'string' },
        tipo_operacion_id: { type: 'string' },
        nombre_fantasia: { type: 'null' },
        cod_cliente: { type: 'string' },
        active: { type: 'boolean' },
        deleted: { type: 'boolean' },
        deleted_at: { type: 'string', format: 'date-time' },
        created_at: { type: 'string', format: 'date-time' },
        updated_at: { type: 'string', format: 'date-time' },
        usuario: { type: 'null' },
      },
    },
  },
};
